var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 161,
    viewBox: "0 0 171 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_313)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.621783,
    y: 0.762408,
    width: 106.442,
    height: 136.43,
    rx: 2.62299,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.749425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7876,
    y: 82.6914,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7876,
    y: 68.0615,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7876,
    y: 97.3242,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7876,
    y: 111.964,
    width: 58.5284,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6878 27.7213L53.8641 20.8799L37.794 27.7213V35.6544C37.794 40.2395 37.3995 45.0431 42.9044 52.3211C45.8109 56.1637 51.4218 58.4832 53.8641 59.1625C55.7112 58.9199 60.4399 57.212 64.5775 52.3211C69.6878 46.2803 69.7084 39.1721 69.6878 35.6544V27.7213Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3569 41.0953L51.6106 46.0578L60.8267 34.7148",
    stroke: "white",
    strokeWidth: 1.49885,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.413 80.928L139.891 54.4898C143.275 49.6477 142.631 43.0626 138.373 38.968C137.065 37.7107 134.995 37.7186 133.697 38.9859L101.275 70.6425C92.857 78.8615 86.6823 89.0977 83.3383 100.377L74.1774 131.278C69.8943 145.725 80.7575 160.213 95.8263 160.151L142.861 159.955C147.136 159.937 151.203 158.109 154.053 154.922C156.808 151.844 157.529 147.447 155.901 143.65L155.197 142.006C160.337 141.559 164.606 137.856 165.775 132.831L166.077 131.528C166.962 127.723 165.291 123.782 161.941 121.772L162.993 121.456C166.826 120.306 169.466 116.799 169.509 112.798L169.541 109.912C169.592 105.282 166.318 101.28 161.77 100.413C166.182 100.413 169.827 96.9716 170.082 92.5674L170.268 89.3425C170.531 84.7758 166.899 80.928 162.325 80.928H121.413Z",
    fill: "#FFDCD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.506,
    height: 159.888,
    fill: "white",
    transform: "translate(0.24707 0.387695)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcCertificationServiceBody2Mobile.5dba0cd5b037136d9de692db4feb3ed9.svg";
export { ForwardRef as ReactComponent };